<template>
  <div>
    <page-header
      icon="mdi-truck-fast"
      :title="$t('companies_delivery')"
      :subtitle="$t('manage_delivery_companies')"
    >
      <template #actions>
        <v-row no-gutters>
          <primary-button
            @click="editCompany({ ...deliveryCompany })"
            v-if="canManageCompanies && $store.state.restaurant != null"
          >
            <v-icon class="mr-2">mdi-plus-circle</v-icon>
            {{ $t("add") }}
          </primary-button>
          <print-button v-if="$store.state.restaurant != null" @click="print('print')" />
        </v-row>
      </template>
    </page-header>

    <page-toolbar
      v-model="search"
      :search-placeholder="$t('search_delivery_companies_placeholder')"
    />

    <div class="px-6 mt-2">
      <v-data-table
        :headers="headers"
        :items="deliveryCompanies"
        :search="search"
        :loading="isLoading"
        :loading-text="$t('loading_data')"
        class="ordera-box-shadow striped-table"
        show-expand
      >
        <template v-slot:top>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <template v-if="item.children && item.children.length">
            <v-btn
              color="primary"
              dark
              small
              rounded
              @click="expand(true)"
              v-if="!isExpanded && $store.state.restaurant != null"
            >
              <v-icon>mdi-arrow-down</v-icon>
              {{ $t("branches") }}
            </v-btn>
            <v-btn color="primary" dark small rounded @click="expand(false)" v-else>
              <v-icon>mdi-arrow-up</v-icon>
              {{ $t("hide") }}
            </v-btn>
          </template>
        </template>

        <template v-slot:expanded-item="{ item, isExpanded, expand }">
          <template v-if="item.children">
            <td :colspan="headers.length" class="pa-0">
              <v-data-table
                dense
                :headers="headers"
                class="ordera-box-shadow striped-table"
                :items="item.children || []"
                :items-per-page="item.children.length"
                hide-default-footer
                hide-default-header
              >
                <v-spacer></v-spacer>
                <template v-slot:item.is_credit="{ item, index }">
                  <div
                    v-if="
                      $store.state.user.user.type == 'restaurant' ||
                      $store.state.user.user.type == 'admin'
                    "
                    class="text-right"
                  >
                    <span class="d-flex">
                      <v-checkbox
                        v-model="item.is_credit"
                        @change="toggleCompanyCreditStatus(item)"
                      ></v-checkbox>
                      <circle-button
                        @click="openCompanyCreditDialog(item)"
                        color="success darken-2"
                        icon="mdi-currency-eur"
                        :tooltip="$t('tooltip_manage_credit')"
                      />
                    </span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item, index }">
                  <v-btn
                    v-if="canSeeFirmUsers(item)"
                    small
                    color="primary"
                    text
                    :to="{
                      name: 'firma-dostava-id-korisnici',
                      params: {
                        id: item.id,
                        name: item.name,
                        parent_id: item.parent_id,
                      },
                    }"
                  >
                    {{ $t("users") }} {{ item.active_users_count ?? item.users_count }}
                  </v-btn>

                  <template v-if="canManageCompanies">
                    <edit-button class="mr-2" @click="editCompany(item)"></edit-button>
                    <circle-button
                      @click="openCompanySettings(item)"
                      icon="mdi-cog-outline"
                      :tooltip="$t('tooltip_delivery_settings')"
                    />
                  </template>
                </template>
              </v-data-table>
            </td>
          </template>
        </template>
        <template v-slot:item.is_credit="{ item, index }">
          <div
            v-if="
              $store.state.user.user.type == 'restaurant' ||
              $store.state.user.user.type == 'admin'
            "
            class="text-right"
          >
            <span class="d-flex">
              <v-checkbox
                v-model="item.is_credit"
                @change="toggleCompanyCreditStatus(item)"
              ></v-checkbox>
              <circle-button
                @click="openCompanyCreditDialog(item)"
                color="success"
                icon="mdi-currency-eur"
                :tooltip="$t('tooltip_manage_credit')"
              />
            </span>
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters justify="end">
            <v-btn
              small
              color="primary"
              text
              class="mx-2"
              :to="{
                name: 'firma-dostava-id-korisnici',
                params: {
                  id: item.id,
                  name: item.name,
                  parent_id: item.parent_id,
                },
              }"
              v-if="
                canSeeFirmUsers(item) &&
                ((item.restaurant_id &&
                  item.children &&
                  item.children.length == 0) ||
                  !item.hasOwnProperty('children'))
              "
            >
              {{ $t("users") }} {{ item.active_users_count ?? item.users_count }}
            </v-btn>
            <span
              v-if="canManageCompanies"
              style="display: flex; align-items: center"
            >
              <edit-button
                v-if="item.restaurant_id"
                class="mr-2"
                @click="editCompany(item)"
              ></edit-button>
              <circle-button
                v-if="item.restaurant_id"
                @click="openCompanySettings(item)"
                icon="mdi-cog-outline"
              />
            </span>
            <span
              v-else-if="$store.state.user.user.type === 'dostava'"
              style="display: flex; justify-content: center"
            >
              <v-switch
                @click="changeUserDeliveryStatus(item.delivery_company_user[0])"
                v-model="item.delivery_company_user[0].active_company"
                inset
                :false-value="0"
                :true-value="1"
                :label="$t('status')"
              ></v-switch>
              <span
                :style="
                  item.delivery_company_user[0].active_company
                    ? 'background:rgb(90, 228, 90) !important'
                    : 'background:red !important'
                "
                style="
                  padding: 4px;
                  border-radius: 10px;
                  display: block;
                  height: 3px;
                  margin-top: 21px;
                  margin-left: 7px;
                "
              ></span>
            </span>
          </v-row>
        </template>
        <template
          v-if="$store.state.user.user.type == 'restaurant'"
          v-slot:item.status="{ item }"
        >
          <span style="display: flex; justify-content: center; margin-left: 10px">
            <v-switch
              style="padding-top: 15px"
              @click="changeCompanyDeliveryStatus(item.restaurant_delivery_company[0])"
              v-model="item.restaurant_delivery_company[0].active_company"
              inset
              title="Приврмено (де)активрај фирму за доставу. Деактивираним фирмама се не прослеђују наруџбе."
              :false-value="0"
              :true-value="1"
            ></v-switch>
            <span
              :style="
                item.restaurant_delivery_company[0].active_company
                  ? 'background:rgb(90, 228, 90) !important'
                  : 'background:red !important'
              "
              style="
                padding: 4px;
                border-radius: 10px;
                display: block;
                height: 3px;
                margin-top: 23px;
                margin-left: 0px;
              "
            ></span>
          </span>
        </template>
      </v-data-table>
    </div>

    <delivery-report-dialog
      v-model="isReportDialogOpen"
      :delivery-company="selectedDeliveryCompany"
      :delivery-company-users="selectedDeliveryCompanyUsers"
      @close="isReportDialogOpen = false"
      @save="onReportSave"
    />

    <company-credit-dialog
      v-model="isCreditDialogOpen"
      :company="selectedCompanyForCredit"
      @saved="loadDeliveryCompanies()"
    />

    <restaurant-settings-dialog
      v-model="isSettingsDialogOpen"
      :firm="selectedCompany"
      :countries="countries"
      :cities="cities"
      :edited-item="editedCompany"
      @country-change="loadCitiesForCountry"
      @saved="isSettingsDialogOpen = false"
      @close="isSettingsDialogOpen = false"
    />

    <delivery-company-dialog
      v-if="$store.state.user.user.type != 'dostava' && $store.state.restaurant != null"
      v-model="isCompanyDialogOpen"
      :edited-item="editedCompany"
      :companies="deliveryCompanies"
      :countries="countries"
      :cities="cities"
      @company-created="onCompanyCreated"
      @company-updated="onCompanyUpdated"
      @country-change="loadCitiesForCountry"
      @close="closeCompanyDialog"
    />
  </div>
</template>

<script>
import DeliveryCompanyDialog from "@/components/companies/dialogs/DeliveryCompanyDialog.vue";
import DeliveryReportDialog from "@/components/companies/dialogs/DeliveryReportDialog.vue";
import RestaurantSettingsDialog from "@/components/companies/dialogs/RestaurantSettingsDialog.vue";
import CompanyCreditDialog from "@/components/companies/dialogs/CompanyCreditDialog.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import { deliveryCompany } from "@/models/company";
import restaurantService from "@/services/restaurant";
import companyService from "@/services/company";

export default {
  mixins: [hasSnackbar],
  components: {
    DeliveryCompanyDialog,
    DeliveryReportDialog,
    RestaurantSettingsDialog,
    CompanyCreditDialog,
  },
  data: () => ({
    isCompanyDialogOpen: false,
    selectedCompany: {
      settings: {
        confirm_delivery: false,
        order_from_one_shift_to_another: true,
        can_see_report: false,
      },
    },
    cities: [],
    search: "",
    isReportDialogOpen: false,
    isCreditDialogOpen: false,
    isSettingsDialogOpen: false,
    selectedCompanyForCredit: null,
    deliveryCompanies: [],
    editedCompany: { ...deliveryCompany },
    countries: [],
    selectedDeliveryCompanyUsers: [],
    selectedDeliveryCompany: null,
    isLoading: false,
  }),

  computed: {
    // Creating / editing a delivery company (commission, cash limits, liability,
    // JIB/PIB, settings, credit) is an owner action. A dispatcher (admin_delivery)
    // or courier (dostava) must not see those affordances — they only manage the
    // firm's users.
    canManageCompanies() {
      return ["admin", "restaurant"].includes(this.$store.state.user.user.type);
    },
    headers() {
      return [
        {
          text: "ID",
          align: "end",
          value: "id",
        },
        {
          text: this.$t("title"),
          align: "start",
          value: "name",
        },
        {
          text: this.$t("email"),
          align: "start",
          value: "email",
          sortable: false,
        },
        {
          text: this.$t("phone_no"),
          align: "start",
          value: "phone",
          sortable: false,
        },
        {
          text: this.$t("actions"),
          align: "end",
          value: "actions",
          sortable: false,
        },
        {
          text: "",
          value: "data-table-expand",
        },
      ];
    },
  },

  watch: {
    isCompanyDialogOpen(val) {
      val || this.closeCompanyDialog();
    },
  },

  created() {
    this.loadDeliveryCompanies();
    this.loadCountries();
    this.$root.$on("changeWebSite", () => {
      this.loadDeliveryCompanies();
    });
    if (this.$store.state.user.user.type == "restaurant") {
      this.headers.push({
        text: this.$t("status"),
        align: "center",
        value: "status",
        sortable: false,
      });
    }
  },
  methods: {
    // "Korisnici" button visibility. A restaurant user may manage users only for
    // its OWN delivery firm — the one linked to this restaurant with internal: 1
    // (backend gates /companies/:id/users-delivery the same way; external firms
    // return 403). admin sees all; dostava/admin_delivery are bounced to the
    // Kurir app so they never reach this screen.
    canSeeFirmUsers(item) {
      const type = this.$store.state.user.user.type;
      if (type === "restaurant") {
        const restaurantId = this.$store.state.restaurant && this.$store.state.restaurant.id;
        return (item.restaurant_delivery_company || []).some(
          (row) => row.restaurant_id === restaurantId && Number(row.internal) === 1
        );
      }
      return type !== "dostava";
    },
    async changeCompanyDeliveryStatus(item) {
      try {
        item.res_id = item.restaurant_id;
        await companyService.changeCompanyDeliveryStatus(item);
        this.showSuccessSnackbar(this.$t("company_delivery_status_updated"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_company_delivery_status"));
      }
    },
    async changeUserDeliveryStatus(item) {
      try {
        await companyService.changeUserDeliveryStatus(item);
        this.showSuccessSnackbar(this.$t("user_delivery_status_updated"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_user_delivery_status"));
      }
    },
    loadCitiesForCountry() {
      let cityes = [];
      this.countries.filter((item) => {
        item.city.filter((city) => {
          this.editedCompany.country.city.filter((c) => {
            if (city.id == c.id) {
              cityes.push(city);
            }
          });
        });
      });
      this.cities = cityes;
    },
    async loadCountries() {
      try {
        const { data } = await restaurantService.getCountriesAll();
        this.countries = data;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_countries"));
      }
    },
    openCompanySettings(company) {
      if (company.settings == null) {
        company.settings = {
          shift_one: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          shift_two: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          shift_three: {
            delivery_from: "",
            delivery_to: "",
            delivery_from1: "",
            delivery_to1: "",
          },
          confirm_delivery: false,
          order_from_one_shift_to_another: true,
          can_see_report: false,
        };
      } else {
        if (typeof company.settings == "string") {
          if (!JSON.parse(company.settings).order_from_one_shift_to_another) {
            JSON.parse(company.settings)["order_from_one_shift_to_another"] = true;
          }
          company.settings = JSON.parse(company.settings);
        }
      }
      this.selectedCompany = company;
      this.editedCompany = JSON.parse(JSON.stringify(company));
      this.isSettingsDialogOpen = true;
    },
    openCompanyCreditDialog(company) {
      this.selectedCompanyForCredit = company;
      this.isCreditDialogOpen = true;
    },
    async toggleCompanyCreditStatus(company) {
      try {
        await companyService.setIsCredit(company.id, company);
        this.showSuccessSnackbar(this.$t("credit_status_updated"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_updating_credit_status"));
      }
    },
    async loadDeliveryCompanies() {
      this.isLoading = true;
      try {
        const res = await companyService.getDeliveryCompanies();
        let companies = res.data;
        if (this.$store.state.user.user.type == "dostava") {
          const restaurantId = this.$store.state.restaurant.id;
          companies = companies.filter((item) => {
            return (
              item.restaurant_delivery_company &&
              item.restaurant_delivery_company.some(
                (itemR) => itemR.restaurant_id == restaurantId
              )
            );
          });
        }
        this.deliveryCompanies = companies;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_delivery_companies"));
      } finally {
        this.isLoading = false;
      }
    },
    editCompany(company) {
      // Create deep copy of the company
      this.editedCompany = JSON.parse(JSON.stringify(company));
      this.isCompanyDialogOpen = true;
    },
    closeCompanyDialog() {
      this.isCompanyDialogOpen = false;
      this.$nextTick(() => {
        this.editedCompany = { ...deliveryCompany };
      });
    },
    onCompanyCreated(newCompany) {
      // Ensure required properties exist
      if (!newCompany.restaurant_delivery_company) {
        newCompany.restaurant_delivery_company = [];
      }

      // If it's a branch (has parent_id), add it to parent's children
      if (newCompany.parent_id) {
        const parentCompany = this.findCompanyById(newCompany.parent_id);
        if (parentCompany) {
          if (!parentCompany.children) {
            this.$set(parentCompany, "children", []);
          }
          parentCompany.children.push(newCompany);
        }
      } else {
        // It's a main company, add to root level
        this.deliveryCompanies.push(newCompany);
      }
    },
    onCompanyUpdated({ item: updatedCompany }) {
      const companyToUpdate = this.findCompanyById(updatedCompany.id);
      if (companyToUpdate) {
        // Update all properties from the updated company
        Object.keys(updatedCompany).forEach((key) => {
          this.$set(companyToUpdate, key, updatedCompany[key]);
        });
      }
    },

    // Helper method to find a company by ID (searches both main and nested companies)
    findCompanyById(companyId) {
      // Search in main companies
      for (const company of this.deliveryCompanies) {
        if (company.id === companyId) {
          return company;
        }
        // Search in children
        if (company.children && company.children.length > 0) {
          const childCompany = company.children.find((child) => child.id === companyId);
          if (childCompany) {
            return childCompany;
          }
        }
      }
      return null;
    },

    onReportSave() {
      this.isReportDialogOpen = false;
    },

    print() {
      window.print();
    },
  },
};
</script>
